import apiClient, { extractData } from "./client";

export async function getComplaints(params = {}) {
  const response = await apiClient.get("/complaints", { params });
  return extractData(response);
}

export async function getComplaint(id) {
  const response = await apiClient.get(`/complaints/${id}`);
  return extractData(response);
}

export async function getComplaintRecipients() {
  const response = await apiClient.get("/complaints/recipients");
  return extractData(response);
}

export async function createComplaint(data) {
  const response = await apiClient.post("/complaints", data);
  return extractData(response);
}

export async function approveComplaint(id, data = {}) {
  const response = await apiClient.post(`/complaints/${id}/approve`, data);
  return extractData(response);
}

export async function respondToComplaint(id, data = {}) {
  const response = await apiClient.post(`/complaints/${id}/respond`, data);
  return extractData(response);
}

export async function rejectComplaint(id, data = {}) {
  const response = await apiClient.post(`/complaints/${id}/reject`, data);
  return extractData(response);
}

export async function escalateComplaint(id, data = {}) {
  const response = await apiClient.post(`/complaints/${id}/escalate`, data);
  return extractData(response);
}

export async function getComplaintTransferTargets(id) {
  const response = await apiClient.get(`/complaints/${id}/transfer-targets`);
  return extractData(response);
}

export async function transferComplaint(id, data = {}) {
  const response = await apiClient.post(`/complaints/${id}/transfer`, data);
  return extractData(response);
}
